<script setup lang="ts">
withDefaults(
  defineProps<{ width?: string; height?: string; rounded?: boolean; label?: string }>(),
  {
    width: '100%',
    height: '14px',
    rounded: false,
    label: 'Loading',
  },
);
</script>

<template>
  <span
    class="shio-skeleton"
    role="status"
    aria-live="polite"
    :aria-label="label"
    :style="{
      width,
      height,
      borderRadius: rounded ? 'var(--shio-radius-pill)' : undefined,
    }"
  />
</template>

<style scoped>
.shio-skeleton {
  display: block;
}
</style>
